import { Component } from '@theme/component';

/**
 * Toggles a size guide table between inches and centimeters.
 *
 * @extends Component
 */
export class SizeGuideTable extends Component {
  setUnitIn() {
    this.#setUnit('in');
  }

  setUnitCm() {
    this.#setUnit('cm');
  }

  /**
   * @param {'in' | 'cm'} unit
   */
  #setUnit(unit) {
    for (const cell of this.querySelectorAll('[data-in]')) {
      const inches = Number(cell.getAttribute('data-in'));
      if (Number.isNaN(inches)) continue;

      cell.textContent = unit === 'cm' ? (inches * 2.54).toFixed(2) : String(inches);
    }

    for (const button of this.querySelectorAll('.size-guide-table__unit-btn')) {
      const isActive = button.getAttribute('data-unit') === unit;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    }
  }
}

if (!customElements.get('size-guide-table')) customElements.define('size-guide-table', SizeGuideTable);
